<template>
  <div id="app">
    <menubar ref="menubar" />
    <router-view />
  </div>
</template>

<script>
import menubar from "@/components/menubar";

export default {
  name: "App",
  components: {
    menubar
  },
  data: () => {
    return {
      info_visible: false
    };
  },
  methods: {
    toggleInfo() {
      this.info_visible = !this.info_visible;
    }
  }
};
</script>

<style lang="scss">
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

//import fontawesome css
@import "assets/fontawesome/css/all.min.css";

// Set your colors
$primary: rgb(42, 163, 214);
$primary-invert: findColorInvert($primary);
$twitter: #4099ff;
$twitter-invert: findColorInvert($twitter);
$green: rgb(13, 163, 54);
$green-invert: findColorInvert($green);
$red: rgb(186, 10, 44);
$red-invert: findColorInvert($red);

// Setup $colors to use as bulma classes (e.g. 'is-twitter')
$colors: (
  "white": (
    $white,
    $black
  ),
  "black": (
    $black,
    $white
  ),
  "light": (
    $light,
    $light-invert
  ),
  "dark": (
    $dark,
    $dark-invert
  ),
  "primary": (
    $primary,
    $primary-invert
  ),
  "info": (
    $info,
    $info-invert
  ),
  "success": (
    $green,
    $green-invert
  ),
  "warning": (
    $warning,
    $warning-invert
  ),
  "danger": (
    $red,
    $red-invert
  ),
  "twitter": (
    $twitter,
    $twitter-invert
  ),
  "green": (
    $green,
    $green-invert
  )
);

// Links
$link: $primary;
$link-invert: $primary-invert;
$link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
@import "assets/tachyons.min.css";

@font-face {
  font-family: "museo";
  src: url("assets/fonts/museo.otf");
}

.goal-selector {
  .control {
    width: 144px !important;

    .input {
      height: 28px !important;
    }
  }
}

/* PHONE SIZE */
@media screen and (max-width: 768px) {
  .button.is-medium {
    font-size: 0.7em !important;
  }

  .action-buttons {
    margin-top: 10px;
    float: right;
    padding-right: 10px;
  }

  .action-button {
    float: right;
    padding-right: 10px;
  }

  .b-text-input {
    font-size: inherit !important;
  }

  .content table td,
  .content table th {
    padding: 2px 2px !important;
  }

  .tag {
    font-size: 0.9em !important;
    padding: 0 !important;
  }

  .b-table {
    font-size: 0.7em !important;
  }

  .control {
    //Selects
    font-size: 0.8em !important;

    .textarea {
      font-size: 1em !important;
      margin-top: -10px;
    }

    height: 0px !important;
    .button {
      font-size: inherit !important;
    }

    .input {
      font-size: inherit;
    }
  }

  .card {
    padding-top: 10px !important;
    padding-left: 4px !important;
    padding-right: 4px !important;
    overflow: hidden !important;

    .card-inner {
      padding-bottom: 5px !important;
    }

    .challenge-container {
      margin: 20px 5px 5px 5px !important;
      padding: 5px 0 !important;
      border-radius: 10px !important;
      border: 1px solid white;
    }

    .card-title {
      font-size: 0.9em !important;
      padding-top: 5px !important;
      color: rgb(42, 163, 214) !important;
    }

    .versus-block {
      font-size: 0.8em !important;
    }

    .challenge-result {
      font-size: 0.8em !important;
      margin-top: 10px !important;
    }

    #myProgress {
      height: 15px !important;
      border-radius: 20px !important;
    }

    #myBar {
      height: 15px !important;
      font-size: 0.7em !important;
    }

    #mySecondBar {
      height: 15px !important;
      font-size: 0.7em !important;
    }
  }

  .info-button {
    text-align: center;
    color: rgb(42, 163, 214) !important;
    cursor: pointer !important;
  }

  .content {
    margin-left: 0px !important;
  }

  .page-title {
    font-size: 1.5em !important;
  }

  .page-description {
    margin-top: 15px;
    padding-left: 0px !important;
    display: inline-block;

    .message-body {
      padding: 0 4px !important;
    }
  }

  .page-description.hidden {
    display: none !important;
  }

  .container {
    margin-left: 10px !important;
  }
}

/* DESKTOP SIZE*/
@media screen and (min-width: 768px) {
  .button.is-medium {
    font-size: 1em !important;
  }

  .filter-bar {
    margin-top: 10px;
    align-items: center;
    display: inline-flex;
    margin-bottom: 20px !important;
    // min-height: px;
  }

  .control {
    //Selects
    font-size: 0.8em !important;
    height: 28px !important;
    .button {
      font-size: inherit !important;
    }

    .input {
      font-size: inherit;
    }
  }

  .action-buttons {
    position: absolute;
    right: 0px;
    padding-right: 10px;
    margin-top: -30px;
    display: flex;
  }

  .table-wrapper {
    margin-top: 40px;
    overflow: auto;
  }

  .action-button {
    float: right;
    padding-right: 10px;
  }

  .b-table {
    font-size: 0.9em !important;
  }

  .b-text-input {
    outline: 0px !important;
  }

  #app {
    padding-top: 20px !important;
  }

  #weezysTable {
    margin-left: 20px;
  }

  .card {
    padding-top: 10px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;

    .card-inner {
      padding-bottom: 10px !important;
    }

    .challenge-container {
      margin: 25px 10px 10px 10px !important;
      padding: 10px 0 !important;
      border-radius: 10px !important;
      border: 1px solid white;
    }

    .card-title {
      padding-top: 10px !important;
      font-size: 1em !important;
    }

    .versus-block {
      display: flex;
      justify-content: space-around;
    }

    .no-waiting {
      margin-top: 10px;
      text-align: center;
    }

    #myProgress {
      height: 20px;
      border-radius: 20px;
      overflow: hidden;
      display: flex;
      justify-content: space-between;
      margin-left: 5%;
      margin-right: 5%;
      background-color: #eee;
    }

    #myBar {
      height: 20px;
      background-color: red;
      border-top-right-radius: 7px;
      border-bottom-right-radius: 7px;
      font-size: 0.9em !important;
    }

    #mySecondBar {
      height: 20px;
      background-color: rgb(42, 163, 214);
      border-top-left-radius: 7px;
      border-bottom-left-radius: 7px;
      font-size: 0.9em !important;
    }
  }

  .info-button {
    display: none;
  }

  .page-description {
    padding-left: 20px !important;
  }
}

// NORMAL CSS BELOW
.modal.is-active {
  z-index: 9999;
}

.timepicker.control {
  height: fit-content !important;
  .control {
    height: fit-content !important;
  }
}

#app {
  margin: auto !important;
}

a,
button {
  font-family: "museo";
}

body {
  overflow: auto;
  background-color: #fff;
  font-family: "museo" !important;
}
h1 {
  padding: 0;
  margin-top: 0;
}

.control {
  //Selects
  display: inline-block !important;

  .textarea {
    min-height: unset;
  }
}

.table-wrapper:not(:last-child) {
  margin-bottom: 0.5rem;
}

.search-field {
  width: 150px;
  display: inline;
}

.b-text-input {
  text-align: center !important;
  border-color: transparent !important;
  background-color: transparent !important;
  color: #fff !important;
}

.b-table {
  margin-top: 1em;
  width: inherit !important;

  .checkbox-cell {
    vertical-align: middle;
  }
}

.table {
  .tr {
    .is-selected {
      background-color: #4099ff;
    }
  }
}

.card {
  box-shadow: none !important;

  .challenge-result {
    margin-top: 10px !important;
  }

  .card-inner {
    background-color: #2aa3d622 !important;
    border-radius: 10px !important;
  }

  .card-title {
    height: 0px !important;
    text-align: center !important;
    padding-bottom: 0px !important;
    color: rgb(42, 163, 214) !important;
  }

  .challenge-container {
    margin: 25px 10px 10px 10px !important;
    padding: 10px 0 !important;
    border-radius: 10px !important;
    border: 1px solid white;
  }

  .card-title {
    padding-top: 10px !important;
    font-size: 1em !important;
  }

  .versus-block {
    display: flex;
    justify-content: space-around;
  }

  .no-waiting {
    margin-top: 10px;
    text-align: center;
  }

  #myProgress {
    height: 20px;
    border-radius: 20px !important;
    overflow: hidden;
    display: flex;
    justify-content: space-between;
    margin-left: 5%;
    margin-right: 5%;
    background-color: #eee;
  }

  #myBar {
    background-color: red;
    border-top-right-radius: 7px;
    border-bottom-right-radius: 7px;
  }

  #mySecondBar {
    background-color: rgb(42, 163, 214);
    border-top-left-radius: 7px;
    border-bottom-left-radius: 7px;
  }
}

.content {
  margin-left: 220px;
}

.container {
  margin-left: 40px;
}

.page-description {
  width: auto !important;
  display: inline-block !important;
}

.page-title {
  color: rgb(42, 163, 214) !important;
}

//SPECIAL CASE
.waiting-text {
  margin-top: 20px;
}
</style>